const ManageCoursesIndex = () => import(/* webpackChunkName: "admin" */ '@/pages/admin/manageCourses/ManageCoursesIndex')
const ManageCoursesAssignments = () => import(/* webpackChunkName: "admin" */ '@/pages/admin/manageCourses/ManageCoursesAssignments')
const ManageCoursesTitles = () => import(/* webpackChunkName: "admin" */ '@/pages/admin/manageCourses/ManageCoursesTitles')
const ManageCoursesImport = () => import(/* webpackChunkName: "admin" */ '@/pages/admin/manageCourses/ManageCourseTitlesImport.vue')
const ManageCoursesRecycleBin = () => import(/* webpackChunkName: "admin" */ '@/pages/admin/manageCourses/ManageCoursesRecycleBin')
const ManageCoursesAddNewCourse = () => import(/* webpackChunkName: "admin" */ '@/pages/admin/manageCourses/ManageCoursesAddNewCourse')
const ManageCoursesEditCourse = () => import(/* webpackChunkName: "admin" */ '@/pages/admin/manageCourses/ManageCoursesEditCourse')

export default [
  {
    path: '/admin/manage-courses',
    name: 'ManageCoursesIndex',
    component: ManageCoursesIndex,
    redirect: { name: 'ManageCoursesAssignments' },
    children: [
      {
        path: 'assignments',
        name: 'ManageCoursesAssignments',
        component: ManageCoursesAssignments
      },
      {
        path: 'titles',
        name: 'ManageCoursesTitles',
        component: ManageCoursesTitles
      },
      {
        path: 'import',
        name: 'ManageCoursesImport',
        component: ManageCoursesImport
      },
      {
        path: 'recycle-bin',
        name: 'ManageCoursesRecycleBin',
        component: ManageCoursesRecycleBin
      },
      {
        path: 'add-new-course',
        name: 'ManageCoursesAddNewCourse',
        component: ManageCoursesAddNewCourse
      },
      {
        path: 'edit-course/:id',
        name: 'ManageCoursesEditCourse',
        component: ManageCoursesEditCourse
      }
    ]
  }
]
